import { cn } from '@dz-web/esboot-browser';
import { memo, useMemo } from 'react';

import Icon from '../../images/circle-check-icon.svg';
import companyBarBg from '../../images/company-bar.png';

import './company-intro.scss';

export const CompanyIntro = memo(() => {
  const infos = useMemo(
    () => [
      {
        title: '香港頂尖的金融市場資訊和分析供應商',
        desc: '提供股票分析終端及交易所市場數據',
        showIcon: true,
      },
      {
        title: '交易所的持牌市場數據供應商',
        desc: '可提供公司資料和財務數據與及公司行動',
        showIcon: true,
      },
      {
        title: '獲授權在中國境內提供金融信息服務',
        desc: '持有國家互聯網信息辦公室發出之《外國機構在中國境內提供金融信息服務許可證》',
        showIcon: true,
      },
      {
        title: '應用簡介',
        desc: 'PowerTicker 由 MegaHub 傾力打造，專注於港股與美股市場的專業級實時股票分析工具，我們提供直達交易所的實時串流報價，並結合獨家研發的技術指標，旨在為投資者提供深度、精準的市場分析。',
        showIcon: false,
        emphasizeDesc: true,
      },
    ],
    [],
  );

  return (
    <div styleName="container">
      <img src={companyBarBg} alt="" styleName="bar-bg" />
      <div styleName="info-list">
        {infos.map((info) => (
          <div key={info.title} styleName="info-item">
            <div styleName="title">
              <div styleName="title-icon-wrapper">
                <Icon
                  styleName={cn('icon', {
                    hidden: !info.showIcon,
                  })}
                />
              </div>
              <div>{info.title}</div>
            </div>
            <div
              styleName={cn('desc', {
                emphasize: info.emphasizeDesc,
              })}
            >
              {info.desc}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});
